import { Contact } from './contact.model';

export interface Company {
  id: number;
  timezone?: string;
  emails?: {
    [key: string]: string;
  };
  phoneNumbers?: {
    [key: string]: string;
  };
  name: string;
  address1?: string;
  address2?: string;
  city?: string;
  postalCode?: string;
  state?: string;
  website?: string;
  note?: string;
  photo?: string | null;
  zip?: string;
  color?: string;
  totalContacts?: number;
}

export type ContactType = Company & Contact;

export const companyFields = [
  'id',
  'timezone',
  'emails',
  'phone_numbers',
  'name',
  'address1',
  'address2',
  'city',
  'postal_code',
  'state',
  'website',
  'note',
  'photo',
  'zip',
  'color',
];

export const companyListFields = ['name', 'photo', 'color', 'totalContacts'];
